<template>
  <div>
    <mmf-dim-search
      :value="value"
      :entity="options"
      :validate="config.validate"
      :bindId="config.bindId"
      :bindProp="config.bindProp"
      :submitProp="config.submitProp"
      @input="updateValue"
      v-if="!displayAsConstant"
    ></mmf-dim-search>
    <span v-if="displayAsConstant">{{showValue}}</span>
  </div>
</template>

<script>
import MmfDimSearch from "@/components/MMFDimSearch.vue";
import { mapActions } from "vuex";

export default {
  components: {
    MmfDimSearch
  },
  props: {
    // 发送请求的 url
    url: {
      type: String
    },
    // 输入的数据
    value: {},
    // 配置项
    config: {
      type: Object,
      default: {
        validate: "", // 参数检查，可以是正则表达式等
        bindId: "", // 绑定的 id, (id 相同的对象会被绑定)
        bindProp: "text", // 显示的属性的名称
        submitProp: "value" // 提交的属性
      }
    },
    // 显示为普通文本
    displayAsConstant: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [] // 选项列表
    };
  },
  computed: {
    /**
     * 根据绑定数据获取对应的显示文本
     * @example
     * // bindProp = 'name'
     * // submitProp = 'id'
     * // value = 1
     * // options = [{id:0,name:'a'}, {id:1, name:'b'}]
     * showValue() // 'b'
     */
    showValue() {
      const bindProp = this.config.bindProp;
      const submitProp = this.config.submitProp;
      const value = this.value;
      const options = this.options;
      const noReasult = "";

      let result = options.filter(row => row[submitProp] == value);
      return (result[0] && result[0][bindProp]) || noReasult;
    }
  },
  methods: {
    ...mapActions("dimSearch", ["search"]),
    updateValue(value) {
      this.$emit("input", value);
    }
  },
  created() {
    this.search({ url: this.url })
      .then(data => {
        this.options = data;
      })
      .catch(err => {
        console.error(err);
      });
  }
};
</script>